import script from "./AppSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./AppSidebar.vue?vue&type=style&index=0&id=d4ed9f1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4ed9f1e"]])

export default __exports__